import { ContractRuleStatus } from '../../__generated__/api'

export const isPaidByOHC = (status: ContractRuleStatus, isImpersonated?: boolean) =>
  status !== ContractRuleStatus.Disallowed &&
  status !== ContractRuleStatus.PaymentCommitmentDisallowed &&
  (status !== ContractRuleStatus.AssessmentRequired ||
    (isImpersonated && status === ContractRuleStatus.AssessmentRequired))
